import { useEffect } from "react";
import { Sparkles } from "lucide-react";

export function MagicMyMessaging() {
  useEffect(() => {
    const existing = document.querySelector(
      'script[src="https://www.yoursiteyourway.com/embed.js"]'
    );
    if (existing) return;
    const script = document.createElement("script");
    script.src = "https://www.yoursiteyourway.com/embed.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <section id="free-tool" className="bg-secondary text-secondary-foreground py-20 md:py-28 relative overflow-hidden pb-[45px] pt-[90px] scroll-mt-24">
      <div
        aria-hidden
        className="pointer-events-none absolute -top-24 -right-24 h-72 w-72 rounded-full bg-primary/30 blur-3xl"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute -bottom-24 -left-24 h-72 w-72 rounded-full bg-primary/20 blur-3xl"
      />
      <div className="relative mx-auto max-w-3xl px-6 text-center">
        <div className="inline-flex items-center gap-2 rounded-full bg-primary/15 px-3 py-1 text-xs font-bold uppercase tracking-wider text-primary">
          <Sparkles className="h-3.5 w-3.5" />
          Free Tool
        </div>
        <p className="mt-6 text-4xl md:text-5xl font-bold leading-snug text-white">
          Magic My Messaging
        </p>
        <p className="mt-5 text-base md:text-lg text-white/75">
          Paste your blah bio or sales copy and get back something that makes your clients think...."Holy shit, you're in my head!!"
        </p>
        <p className="mt-2 text-sm text-white/60">
          Don't see the messaging tool? Refresh this page to load.
        </p>

        <div id="fix-my-messaging" className="mt-10" />
      </div>
    </section>
  );
}
